import { AbstractControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';
import { Directive } from '@angular/core';
import * as moment from 'moment';

export function dateValidator(): ValidatorFn {
  return (control: AbstractControl): { [p: string]: any } | null => {
    const { value } = control;
    if (!value) return null;
    const parsedDate = moment(value, 'DD/MM/YYYY', true);

    if (
      parsedDate.isValid() &&
      parsedDate.format('DD/MM/YYYY') === value &&
      parsedDate.isSameOrBefore(moment(), 'day')
    ) {
      return null;
    } else {
      return { [DateValidAndBeforeDirective.key]: true };
    }
  };
}

@Directive({
  selector: '[appDateValidAndBeforeDirective]',
  providers: [{ provide: NG_VALIDATORS, useExisting: DateValidAndBeforeDirective, multi: true }]
})
export class DateValidAndBeforeDirective {
  static key: string = 'validDate';

  validate(control: AbstractControl): { [key: string]: any } {
    // @ts-ignore
    return dateValidator()(control);
  }
}
